<template>
  <div id="app">
    <login></login>
    <menutop></menutop>
    <div class="container-fluid" id="dvconteudoapp"> 
      <div class="row" style="margin-right: 0;">
        <div class="col-sm-1 sidebarpai" style="width: 50px;">
          <div class="sidebar">
           </div>
        </div>
        <div class="col">
          <!-- <menutop></menutop> -->
          <router-view></router-view>
        </div>
      </div>
    </div>      
  </div>
</template>
<style>
  #dvconteudoapp{
    margin-top: 70px;
    padding: 0px;
    /* margin-bottom: 15px; */
  }
  #dvcrud{
    margin-bottom: 15px;
  }
  #app{
    background-color: white;
  }
  .sidebar {
    height: 100%;
    width: 40px; /* Largura do sidebar */
    background-color: #333;
    padding-top: 20px;
  }

  .sidebar a {
    padding: 10px 0;
    text-align: center;
    display: block;
    color: white;
  }
  @media (max-width: 400px) {
    .sidebarpai{
      display: none;
    }
  }
  
  
</style>
<script>

import menutop from './views/menutop.vue'
import login from './views/login'
import util from './utilitarios/util.js'

export default {
  name: 'app',
  components: {   
      'menutop' : menutop,
      'login'   : login
  },
  mounted:function(){    
  },
  methods:{
  },
  computed: {
  }
}
</script>
